import { CognitoUserSession } from 'amazon-cognito-identity-js';

import { DecodedToken } from '../types';

const getDecodedToken = (currentSession: CognitoUserSession) =>
    currentSession.getIdToken().decodePayload() as DecodedToken;

export default getDecodedToken;
